"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = require("./index");
var _TableFooterPagination = _interopRequireDefault(require("./TableFooterPagination.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var TableFooterPagination = function TableFooterPagination(_ref) {
  var checkbox = _ref.checkbox,
    isLoading = _ref.isLoading,
    pagination = _ref.pagination,
    tableFooterTracking = _ref.tableFooterTracking,
    footerActions = _ref.footerActions,
    disableLastPageArrow = _ref.disableLastPageArrow,
    withFormattedData = _ref.withFormattedData;
  return /*#__PURE__*/_react["default"].createElement(_TableFooterPagination["default"], null, /*#__PURE__*/_react["default"].createElement(_index.TableFooterActions, {
    onClear: checkbox ? checkbox.onClear : undefined,
    clearLabel: checkbox ? checkbox.clearLabel : '',
    selectedItems: checkbox ? checkbox.selectedItems.length : 0,
    footerActions: footerActions
  }), /*#__PURE__*/_react["default"].createElement(_index.TablePagination, _extends({}, pagination, {
    tableFooterTracking: tableFooterTracking,
    className: "pagination-wrapper ".concat(pagination.className ? pagination.className : ''),
    isTableLoading: isLoading,
    disableLastPageArrow: disableLastPageArrow,
    withFormattedData: withFormattedData
  })));
};
TableFooterPagination.defaultProps = {
  checkbox: null,
  isLoading: false,
  pagination: null,
  footerActions: [],
  tableFooterTracking: {
    tablePaginationFirst: function tablePaginationFirst() {},
    tablePaginationPrev: function tablePaginationPrev() {},
    tablePaginationNext: function tablePaginationNext() {},
    tablePaginationLast: function tablePaginationLast() {}
  }
};
TableFooterPagination.propTypes = {
  checkbox: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onClear: _propTypes["default"].func,
    clearLabel: _propTypes["default"].string,
    selectedItems: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
    selectAll: _propTypes["default"].func,
    pagesSelected: _propTypes["default"].shape({})
  }),
  isLoading: _propTypes["default"].bool,
  pagination: _propTypes["default"].shape({
    totalResults: _propTypes["default"].number.isRequired,
    resultsPerPage: _propTypes["default"].number.isRequired,
    currentPage: _propTypes["default"].number.isRequired,
    className: _propTypes["default"].string
  }),
  tableFooterTracking: _propTypes["default"].shape({
    tablePaginationFirst: _propTypes["default"].func,
    tablePaginationPrev: _propTypes["default"].func,
    tablePaginationNext: _propTypes["default"].func,
    tablePaginationLast: _propTypes["default"].func
  }),
  footerActions: _propTypes["default"].arrayOf(_propTypes["default"].node),
  disableLastPageArrow: _propTypes["default"].bool.isRequired,
  withFormattedData: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = TableFooterPagination;